import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import BajaAltaMultiple from "../../BajaAltaMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import qrcode from "qrcode-js";
import moment from "moment";

function ReporteVentasArticulos() {
  const { user } = useContext(AuthContext);
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_UNIDADES_NEGOCIO = process.env.REACT_APP_URL_UNIDADES_NEGOCIO;
  const URL_INVENTARIOS_DIAS = process.env.REACT_APP_URL_INVENTARIOS_DIAS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 15);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");

  const [marcas, setMarcas] = useState([]);
  const [selectedMarca, setSelectedMarca] = useState("");

  const [unidadesNegocio, setUnidadesNegocio] = useState([]);
  const [selectedUnidadNegocio, setSelectedUnidadNegocio] = useState("");

  const [totalTotalCantidad, setTotalTotalCantidad] = useState(0);
  const [totalTotalCantidadEntregado, setTotalTotalCantidadEntregado] = useState(0);
  const [totalTotalCantidadPorEntregar, setTotalTotalCantidadPorEntregar] = useState(0);
  const [totalTotalDinero, setTotalTotalDinero] = useState(0);
  const [totalTotalDineroBruto, setTotalTotalDineroBruto] = useState(0);

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [cargando, setCargando] = useState(true);
  const [fechaModificada, setFechaModificada] = useState(false);

  const [activo, setActivo] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    // timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  useEffect(() => {
  if (cargando) {
    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`, // Ícono de carga animado
      title: "Danos unos segundos....",
      customClass: {
        icon: 'animated-icon'
      }
    });
  }
  }, [cargando]);

  useEffect(() => {
  setCargando(true);

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  Promise.all([
    axios.get(
      `${URL_ARTICULOS_SURTIDOS}FechasVentas/${selectedFechaInicio}/${selectedFechaFin}`,
      { headers }
    ),
    axios.get(
      `${URL_INVENTARIOS_DIAS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
      { headers }
    ),
  ])
    .then(([responseVentas, responseInventarios]) => {
      const ventasAgrupadas = responseVentas.data || [];
      const inventariosDias = responseInventarios.data || [];

      const mapaInventariosDias = new Map(
        inventariosDias.map((a) => [
          `${a.idArticulo}_${a.idArea}`,
          {
            diasInventario: a.diasInventario || 0,
            diasSinInventario: a.diasSinInventario || 0,
          },
        ])
      );

      const conInventario = ventasAgrupadas.map((item) => {
        const invKey = `${item.idArticulo}_${item.idArea}`;
        const invData = mapaInventariosDias.get(invKey) || {
          diasInventario: 0,
          diasSinInventario: 0,
        };
        return {
          ...item,
          diasInventario: invData.diasInventario,
          diasSinInventario: invData.diasSinInventario,
        };
      });

      setComments(conInventario);
      setCargando(false);
      Toast.close();
    })
    .catch((err) => {
      console.log(err);
      setCargando(false);
      Toast.close();
    });

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
        .get(URL_MARCAS, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allMarcas = response.data;
          setMarcas(allMarcas);
        })
        .catch((err) => {
          console.log(err);
        });

        axios
        .get(URL_UNIDADES_NEGOCIO, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allUnidadesNegocio = response.data;
          setUnidadesNegocio(allUnidadesNegocio);
        })
        .catch((err) => {
          console.log(err);
        });

  }, []);

function BuscaInfo() {
  setComments([]);
  setCargando(true);

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  Promise.all([
    axios.get(
      `${URL_ARTICULOS_SURTIDOS}FechasVentas/${selectedFechaInicio}/${selectedFechaFin}`,
      { headers }
    ),
    axios.get(
      `${URL_INVENTARIOS_DIAS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
      { headers }
    ),
  ])
    .then(([responseVentas, responseInventarios]) => {
      const ventasAgrupadas = responseVentas.data || [];
      const inventariosDias = responseInventarios.data || [];

      const mapaInventariosDias = new Map(
        inventariosDias.map((a) => [
          `${a.idArticulo}_${a.idArea}`,
          {
            diasInventario: a.diasInventario || 0,
            diasSinInventario: a.diasSinInventario || 0,
          },
        ])
      );

      const conInventario = ventasAgrupadas.map((item) => {
        const invKey = `${item.idArticulo}_${item.idArea}`;
        const invData = mapaInventariosDias.get(invKey) || {
          diasInventario: 0,
          diasSinInventario: 0,
        };
        return {
          ...item,
          diasInventario: invData.diasInventario,
          diasSinInventario: invData.diasSinInventario,
        };
      });

      setComments(conInventario);
      setCargando(false);
      setFechaModificada(false);
      Toast.close();
    })
    .catch((err) => {
      console.log(err);
      setCargando(false);
      setFechaModificada(false);
      Toast.close();
    });
}


  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        // (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        // (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == "" || selectedCliente == a.idCliente)&&
        (selectedMarca == "" || selectedMarca == a.idMarca)&&
        (selectedUnidadNegocio == "" || selectedUnidadNegocio == a.idUnidadNegocio)
      ) {
        return [
          a.SKU,
          a.nombre,
          a.marca,
          a.cliente,
          new Intl.NumberFormat("en-US").format(a.diasInventario),
          new Intl.NumberFormat("en-US").format(a.cantidad),
          new Intl.NumberFormat("en-US").format(a.entregado),
          new Intl.NumberFormat("en-US").format(a.porEntregar),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precioPromedio),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalPrecio),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Reporte Ventas Articulo`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "SKU",
          "Nombre",
          "Marca",
          "Cliente",
          "Dias Inv.",
          "Cantidad",
          "Entregado",
          "Por Entregar",
          "Precio Promedio",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    // doc.save(`Ventas.pdf`);
    window.open(doc.output("bloburl"), "_blank");
  }

function excel() {
  // 1. Filtrado por cliente y marca
  let filtered = comments.filter(
    (a) =>
      (selectedCliente === "" || selectedCliente === a.idCliente) &&
      (selectedMarca === "" || selectedMarca === a.idMarca)&&
        (selectedUnidadNegocio == "" || selectedUnidadNegocio == a.idUnidadNegocio)
  );

  // 2. Filtro por texto de búsqueda
  if (search && search.trim() !== "") {
    const searchLower = search.toLowerCase();
    filtered = filtered.filter((a) =>
      (a.SKU && a.SKU.toLowerCase().includes(searchLower)) ||
      (a.nombre && a.nombre.toLowerCase().includes(searchLower)) ||
      (a.marca && a.marca.toLowerCase().includes(searchLower)) ||
      (a.cliente && a.cliente.toLowerCase().includes(searchLower)) ||
      (a.area && a.area.toLowerCase().includes(searchLower)) ||
      (a.diasInventario != null && a.diasInventario.toString().includes(searchLower)) ||
      (a.cantidad != null && a.cantidad.toString().includes(searchLower)) ||
      (a.entregado != null && a.entregado.toString().includes(searchLower)) ||
      (a.porEntregar != null && a.porEntregar.toString().includes(searchLower)) ||
      (a.precioPromedio != null && a.precioPromedio.toString().includes(searchLower)) ||
      (a.precioPromedioBruto != null && a.precioPromedioBruto.toString().includes(searchLower)) ||
      (a.totalPrecioBruto != null && a.totalPrecioBruto.toString().includes(searchLower)) ||
      (a.totalPrecio != null && a.totalPrecio.toString().includes(searchLower))
    );
  }

  // 3. Mapear datos a exportar
  const dataExcel = filtered.map((a) => ({
    SKU: a.SKU,
    Nombre: a.nombre,
    Marca: a.marca,
    Cliente: a.cliente,
    Almacen: a.area,
    DiasInventario: a.diasInventario,
    CantidadVendida: a.cantidad,
    CantidadEntregada: a.entregado,
    CantidadPorEntregar: a.porEntregar,
    PrecioPromedioBruto: Number(a.precioPromedioBruto.toFixed(2)),
    PrecioPromedioNeto: Number(a.precioPromedio.toFixed(2)),
    TotalBruto: Number(a.totalPrecioBruto.toFixed(2)),
    TotalNeto: Number(a.totalPrecio.toFixed(2)),
  }));

  const dataExcelLimpia = dataExcel.filter((el) => el != null);

  const option = {
    fileName: "ReporteVentasArticulos",
    datas: [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ReporteVentasArticulos",
        sheetFilter: [
          "SKU",
          "Nombre",
          "Marca",
          "Cliente",
          "Almacen",
          "DiasInventario",
          "CantidadVendida",
          "CantidadEntregada",
          "CantidadPorEntregar",
          "PrecioPromedioBruto",
          "PrecioPromedioNeto",
          "TotalBruto",
          "TotalNeto",
        ],
        sheetHeader: [
          "SKU",
          "Nombre",
          "Marca",
          "Cliente",
          "Almacen",
          "DiasInventario",
          "CantidadVendida",
          "CantidadEntregada",
          "CantidadPorEntregar",
          "PrecioPromedioBruto",
          "PrecioPromedioNeto",
          "TotalBruto",
          "TotalNeto",
        ],
      },
    ],
  };

  const toExcel = new ExportJsonExcel(option);
  toExcel.saveExcel();
}


  function enviaMail() {
    const data = comments.map((a) => {
      if (
        // (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        // (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == "" || selectedCliente == a.idCliente)&&
        (selectedMarca == "" || selectedMarca == a.idMarca)&&
        (selectedUnidadNegocio == "" || selectedUnidadNegocio == a.idUnidadNegocio)
      ) {
        return [
          a.SKU,
          a.nombre,
          a.marca,
          a.cliente,
          new Intl.NumberFormat("en-US").format(a.diasInventario),
          new Intl.NumberFormat("en-US").format(a.cantidad),
          new Intl.NumberFormat("en-US").format(a.entregado),
          new Intl.NumberFormat("en-US").format(a.porEntregar),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precioPromedio),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalPrecio),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Reporte Ventas Articulo`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "SKU",
          "Nombre",
          "Marca",
          "Cliente",
          "Dias Inventario",
          "Cantidad",
          "Entregado",
          "Por Entregar",
          "Precio Promedio",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Reporte Ventas Articulo",
          email: mailTo,
          fileName: "ReporteVentasArticulos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el Reporte Ventas Articulo.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "SKU", field: "SKU", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Marca", field: "marca", sortable: true },
    { name: "Cliente", field: "cliente", sortable: true },
    { name: "Almacen", field: "area", sortable: true },
    { name: "Dias Inv.", field: "diasInventario", sortable: true },
    { name: "Cantidad Vendida", field: "cantidad", sortable: true },
    { name: "Cantidad Entregada", field: "entregado", sortable: true },
    { name: "Cantidad Por Entregar", field: "porEntregar", sortable: true },
    { name: "Precio Promedio Bruto", field: "precioPromedioBruto", sortable: true },
    { name: "Precio Promedio Neto", field: "precioPromedio", sortable: true },
    { name: "Total Bruto", field: "totalPrecioBruto", sortable: true },
    { name: "Total Neto", field: "totalPrecio", sortable: true },
    
  ];


  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.SKU.toLowerCase().includes(search.toLowerCase()) ||
        comment.nombre.toLowerCase().includes(search.toLowerCase()) ||
        comment.marca.toLowerCase().includes(search.toLowerCase()) ||
          comment.cliente.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.diasInventario.toString().includes(search) ||
          comment.cantidad.toString().includes(search) ||
          comment.entregado.toString().includes(search) ||
          comment.porEntregar.toString().includes(search) ||
          comment.precioPromedio.toString().includes(search) ||
          comment.precioPromedioBruto.toString().includes(search) ||
          comment.totalPrecioBruto.toString().includes(search) ||
          comment.totalPrecio.toString().includes(search) 
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idCliente.includes(selectedCliente)
      );
    }
    if (selectedMarca) {
      computedComments = computedComments.filter((e) =>
        e.idMarca.includes(selectedMarca)
      );
    }

    if (selectedUnidadNegocio) {
      computedComments = computedComments.filter((e) =>
        e.idUnidadNegocio.includes(selectedUnidadNegocio)
      );
    }

    setTotalItems(computedComments.length);

    let cant = computedComments.map((c) => parseFloat(c.cantidad));
    let Tcant = cant.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalCantidad(Tcant);

    let cantEnt = computedComments.map((c) => parseFloat(c.entregado));
    let TcantEnt = cantEnt.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalCantidadEntregado(TcantEnt);

    let cantPor = computedComments.map((c) => parseFloat(c.porEntregar));
    let TcantPor = cantPor.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalCantidadPorEntregar(TcantPor);

    let cantTot = computedComments.map((c) => parseFloat(c.totalPrecio));
    let TcantTot = cantTot.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalDinero(TcantTot);

    let cantTotBruto = computedComments.map((c) => parseFloat(c.totalPrecioBruto));
    let TcantTotBruto = cantTotBruto.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalDineroBruto(TcantTotBruto);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "diasInventario" &&
      sorting.field != "cantidad" &&
      sorting.field != "entregado" &&
      sorting.field != "porEntregar" &&
      sorting.field != "precioPromedio" &&
      sorting.field != "precioPromedioBruto" &&
      sorting.field != "totalPrecioBruto" &&
      sorting.field != "totalPrecio"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (
        sorting.field == "diasInventario" ||
        sorting.field == "cantidad" ||
        sorting.field == "entregado" ||
        sorting.field == "porEntregar" ||
        sorting.field == "precioPromedio" ||
        sorting.field == "precioPromedioBruto" ||
        sorting.field == "totalPrecioBruto" ||
        sorting.field == "totalPrecio"
      )
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (
        sorting.field == "diasInventario"||
        sorting.field == "cantidad"||
        sorting.field == "entregado" ||
        sorting.field == "porEntregar" ||
        sorting.field == "precioPromedio" ||
        sorting.field == "precioPromedioBruto" ||
        sorting.field == "totalPrecioBruto" ||
        sorting.field == "totalPrecio"
      )
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedMarca,
    selectedUnidadNegocio,
    selectedFechaInicio,
    selectedFechaFin,
  ]);


  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_ventas ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuVentas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Reporte Ventas Articulo</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Reporte Ventas Articulo</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                  setFechaModificada(true);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                  setFechaModificada(true);
                }}
              />
            </Col>
            <Col md={1}>
            <h4></h4>
            <Button
              size="sm"
              className="btn"
              id="botonListado"
              onClick={BuscaInfo}
              color={fechaModificada ? "danger" : "info"}
            >
              Actualizar
            </Button>
          </Col>
            <Col md={2}>
              <Label>Clientes</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {clientes
                  .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
            <Col md={2}>
              <Label>Marcas</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedMarca}
                onChange={(e) => {
                  setSelectedMarca(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {marcas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
            <Col md={2}>
              <Label>Unidad Negocio</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedUnidadNegocio}
                onChange={(e) => {
                  setSelectedUnidadNegocio(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {unidadesNegocio
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>

            {/* <Col md={2}>
              <Label>Activo</Label>
              <Input
                bsSize="sm"
                type="select"
                value={activo}
                required
                onChange={(e) => {
                  setActivo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Activos</option>
                <option value="No">Inactivos</option>
              </Input>
            </Col> */}
          </Row>
          <br />
          <div className="table-wrapper">
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                  return (
                    <tr>
                      <td>{a.SKU}</td>
                      <td>{a.nombre}</td>
                      <td>{a.marca}</td>
                      <td>{a.cliente}</td>
                      <td>{a.area}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.diasInventario)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.cantidad)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.entregado)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.porEntregar)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precioPromedioBruto)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precioPromedio)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalPrecioBruto)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalPrecio)}</td>
                    </tr>
                  );
              })}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">TOTAL</td>
                <td className="negrita">{new Intl.NumberFormat("en-US").format(totalTotalCantidad)}</td>
                <td className="negrita">{new Intl.NumberFormat("en-US").format(totalTotalCantidadEntregado)}</td>
                <td className="negrita">{new Intl.NumberFormat("en-US").format(totalTotalCantidadPorEntregar)}</td>
                <td></td>
                <td></td>
                <td className="negrita">{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalDineroBruto)}</td>
                <td className="negrita">{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalDinero)}</td>
              </tr>
            </tbody>
          </Table>
          </div>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      {loader}
    </>
  );
}

export default ReporteVentasArticulos;
